<template>
    <content-page title="Επικοινωνία" subtitle="Για εγγραφές, απορίες και ό,τι άλλο χρειαστείς" icon="mdi-message-text-outline">
        <div class="contacts">
            <div v-for="(contact, index) in contacts" :key="index" class="contact-card">
                <a :href="`tel:${contact.phone}`" class="contact-row">
                    <span class="contact-row__icon custom-orange">
                        <v-icon small color="white">mdi-phone</v-icon>
                    </span>
                    <span class="contact-row__text">
                        <span class="contact-row__label">Κινητό</span>
                        <span class="contact-row__value">{{ formatPhone(contact.phone) }}</span>
                    </span>
                </a>
                <a :href="`mailto:${contact.email}`" class="contact-row">
                    <span class="contact-row__icon custom-orange">
                        <v-icon small color="white">mdi-email-outline</v-icon>
                    </span>
                    <span class="contact-row__text">
                        <span class="contact-row__label">Email</span>
                        <span class="contact-row__value">{{ contact.email }}</span>
                    </span>
                </a>
            </div>
        </div>

        <div class="contact-links">
            <v-btn depressed class="custom-orange white--text contact-links__btn" :to="{ name: 'Register' }">
                <v-icon small left>mdi-account-plus-outline</v-icon>
                Εγγραφή ομάδας
            </v-btn>
            <v-btn outlined color="orange darken-2" class="contact-links__btn" :to="{ name: 'Regulations' }">
                <v-icon small left>mdi-gavel</v-icon>
                Κανονισμός
            </v-btn>
        </div>
    </content-page>
</template>

<script>
    import ContentPage from '@/components/ContentPage'
    export default {
        components: { ContentPage },
        data() {
            return {
                contacts: [
                    { phone: '+306979575906', email: 'ivalmas@backinthegame.gr' },
                    { phone: '+306979607540', email: 'gvalmas@backinthegame.gr' }
                ]
            }
        },
        methods: {
            // +306979575906 -> +30 697 957 5906
            formatPhone(phone) {
                return phone.replace(/^(\+30)(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3 $4')
            }
        }
    }
</script>

<style scoped>
.contacts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px;
}

.contact-card {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 14px;
    border-radius: 12px;
    background: #f7f7f8;
    border-top: 3px solid #ff7133;
}

.contact-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    border-radius: 8px;
    color: inherit !important;
    text-decoration: none;
    font-weight: 400 !important;
    transition: background 0.15s ease;
}

.contact-row:hover {
    background: #fff3ec;
}

.contact-row__icon {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
}

.contact-row__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.contact-row__label {
    color: rgba(0, 0, 0, 0.5);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    line-height: 1.3;
}

.contact-row__value {
    font-weight: 700;
    line-height: 1.4;
    word-break: break-all;
}

.contact-links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 24px;
}

.contact-links__btn {
    font-weight: 700;
    text-transform: none;
    letter-spacing: normal;
}
</style>
